"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: transfer/transfer-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftransfer%2Ftransfer-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferServiceClient = exports.LookupFeeResponse = exports.LookupFeeRequest = exports.LookupFeeSchemaResponse = exports.LookupFeeSchemaRequest = exports.GetTransferMinimumConfigResponse = exports.GetTransferMinimumConfigRequest = exports.CancelPendingResponse = exports.CancelPendingRequest = exports.UpdateTransferRequestStatusResponse = exports.UpdateTransferRequestStatusRequest = exports.DeleteTransferRequestResponse = exports.DeleteTransferRequestRequest = exports.GetTransferRequestResponse = exports.GetTransferRequestRequest = exports.GetTransferRequestsResponse = exports.GetTransferRequestsRequest = exports.GetEtaResponse = exports.GetEtaRequest = exports.RequestMoneyResponse = exports.RequestMoneyRequest = exports.SendMoneyV2Response = exports.SendMoneyV2Request = exports.TransferMinimumConfig = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const fee_schema_1 = require("../common/fee-schema");
const transfer_request_status_1 = require("../common/transfer-request-status");
const transfer_fee_type_1 = require("./transfer-fee-type");
const transfer_instructions_1 = require("./transfer-instructions");
const transfer_request_1 = require("./transfer-request");
const transfer_status_1 = require("./transfer-status");
const protobufPackage = 'com.step.transfer.proto';
function createBaseTransferMinimumConfig() {
    return {
        cashAdvance: amount_1.Amount.fromPartial({}),
        cardFunding: amount_1.Amount.fromPartial({}),
        suggestedTransfer: amount_1.Amount.fromPartial({}),
    };
}
exports.TransferMinimumConfig = {
    fromJSON(object) {
        const message = {
            cashAdvance: isSet(object.cashAdvance)
                ? amount_1.Amount.fromJSON(object.cashAdvance)
                : amount_1.Amount.fromPartial({}),
            cardFunding: isSet(object.cardFunding)
                ? amount_1.Amount.fromJSON(object.cardFunding)
                : amount_1.Amount.fromPartial({}),
            suggestedTransfer: isSet(object.suggestedTransfer)
                ? amount_1.Amount.fromJSON(object.suggestedTransfer)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cashAdvance !== undefined) {
            obj.cashAdvance = amount_1.Amount.toJSON(message.cashAdvance);
        }
        if (message.cardFunding !== undefined) {
            obj.cardFunding = amount_1.Amount.toJSON(message.cardFunding);
        }
        if (message.suggestedTransfer !== undefined) {
            obj.suggestedTransfer = amount_1.Amount.toJSON(message.suggestedTransfer);
        }
        return obj;
    },
    create(base) {
        return exports.TransferMinimumConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferMinimumConfig();
        message.cashAdvance = (object.cashAdvance !== undefined && object.cashAdvance !== null)
            ? amount_1.Amount.fromPartial(object.cashAdvance)
            : amount_1.Amount.fromPartial({});
        message.cardFunding = (object.cardFunding !== undefined && object.cardFunding !== null)
            ? amount_1.Amount.fromPartial(object.cardFunding)
            : amount_1.Amount.fromPartial({});
        message.suggestedTransfer =
            (object.suggestedTransfer !== undefined && object.suggestedTransfer !== null)
                ? amount_1.Amount.fromPartial(object.suggestedTransfer)
                : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseSendMoneyV2Request() {
    return { instructions: transfer_instructions_1.TransferInstructions.fromPartial({}), nonce: '' };
}
exports.SendMoneyV2Request = {
    fromJSON(object) {
        const message = {
            instructions: isSet(object.instructions)
                ? transfer_instructions_1.TransferInstructions.fromJSON(object.instructions)
                : transfer_instructions_1.TransferInstructions.fromPartial({}),
            nonce: isSet(object.nonce) ? globalThis.String(object.nonce) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instructions !== undefined) {
            obj.instructions = transfer_instructions_1.TransferInstructions.toJSON(message.instructions);
        }
        if (message.nonce !== '') {
            obj.nonce = message.nonce;
        }
        return obj;
    },
    create(base) {
        return exports.SendMoneyV2Request.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendMoneyV2Request();
        message.instructions = (object.instructions !== undefined && object.instructions !== null)
            ? transfer_instructions_1.TransferInstructions.fromPartial(object.instructions)
            : transfer_instructions_1.TransferInstructions.fromPartial({});
        message.nonce = object.nonce ?? '';
        return message;
    },
};
function createBaseSendMoneyV2Response() {
    return { status: transfer_status_1.TransferStatus.fromPartial({}) };
}
exports.SendMoneyV2Response = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? transfer_status_1.TransferStatus.fromJSON(object.status)
                : transfer_status_1.TransferStatus.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== undefined) {
            obj.status = transfer_status_1.TransferStatus.toJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.SendMoneyV2Response.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendMoneyV2Response();
        message.status = (object.status !== undefined && object.status !== null)
            ? transfer_status_1.TransferStatus.fromPartial(object.status)
            : transfer_status_1.TransferStatus.fromPartial({});
        return message;
    },
};
function createBaseRequestMoneyRequest() {
    return {
        toAccountId: undefined,
        userAccountId: undefined,
        fromAlias: undefined,
        counterpartyAlias: undefined,
        amount: amount_1.Amount.fromPartial({}),
        description: '',
        reimburseTransactionId: '',
    };
}
exports.RequestMoneyRequest = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.toAccountId)) {
            message.toAccountId = globalThis.String(object.toAccountId);
        }
        if (isSet(object.userAccountId)) {
            message.userAccountId = globalThis.String(object.userAccountId);
        }
        if (isSet(object.fromAlias)) {
            message.fromAlias = alias_1.Alias.fromJSON(object.fromAlias);
        }
        if (isSet(object.counterpartyAlias)) {
            message.counterpartyAlias = alias_1.Alias.fromJSON(object.counterpartyAlias);
        }
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.reimburseTransactionId)) {
            message.reimburseTransactionId = globalThis.String(object.reimburseTransactionId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.toAccountId !== undefined) {
            obj.toAccountId = message.toAccountId;
        }
        if (message.userAccountId !== undefined) {
            obj.userAccountId = message.userAccountId;
        }
        if (message.fromAlias !== undefined) {
            obj.fromAlias = alias_1.Alias.toJSON(message.fromAlias);
        }
        if (message.counterpartyAlias !== undefined) {
            obj.counterpartyAlias = alias_1.Alias.toJSON(message.counterpartyAlias);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.reimburseTransactionId !== undefined && message.reimburseTransactionId !== '') {
            obj.reimburseTransactionId = message.reimburseTransactionId;
        }
        return obj;
    },
    create(base) {
        return exports.RequestMoneyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequestMoneyRequest();
        message.toAccountId = object.toAccountId ?? undefined;
        message.userAccountId = object.userAccountId ?? undefined;
        message.fromAlias = (object.fromAlias !== undefined && object.fromAlias !== null)
            ? alias_1.Alias.fromPartial(object.fromAlias)
            : undefined;
        message.counterpartyAlias =
            (object.counterpartyAlias !== undefined && object.counterpartyAlias !== null)
                ? alias_1.Alias.fromPartial(object.counterpartyAlias)
                : undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.description = object.description ?? '';
        message.reimburseTransactionId = object.reimburseTransactionId ?? '';
        return message;
    },
};
function createBaseRequestMoneyResponse() {
    return { request: transfer_request_1.TransferRequest.fromPartial({}) };
}
exports.RequestMoneyResponse = {
    fromJSON(object) {
        const message = {
            request: isSet(object.request)
                ? transfer_request_1.TransferRequest.fromJSON(object.request)
                : transfer_request_1.TransferRequest.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = transfer_request_1.TransferRequest.toJSON(message.request);
        }
        return obj;
    },
    create(base) {
        return exports.RequestMoneyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRequestMoneyResponse();
        message.request = (object.request !== undefined && object.request !== null)
            ? transfer_request_1.TransferRequest.fromPartial(object.request)
            : transfer_request_1.TransferRequest.fromPartial({});
        return message;
    },
};
function createBaseGetEtaRequest() {
    return { source: transfer_instructions_1.TransferSource.fromPartial({}), amount: undefined };
}
exports.GetEtaRequest = {
    fromJSON(object) {
        const message = {
            source: isSet(object.source)
                ? transfer_instructions_1.TransferSource.fromJSON(object.source)
                : transfer_instructions_1.TransferSource.fromPartial({}),
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== undefined) {
            obj.source = transfer_instructions_1.TransferSource.toJSON(message.source);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.GetEtaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEtaRequest();
        message.source = (object.source !== undefined && object.source !== null)
            ? transfer_instructions_1.TransferSource.fromPartial(object.source)
            : transfer_instructions_1.TransferSource.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        return message;
    },
};
function createBaseGetEtaResponse() {
    return { transferEtaMs: '0', transferCutoffTimeMs: '0' };
}
exports.GetEtaResponse = {
    fromJSON(object) {
        const message = {
            transferEtaMs: isSet(object.transferEtaMs) ? globalThis.String(object.transferEtaMs) : '0',
        };
        if (isSet(object.transferCutoffTimeMs)) {
            message.transferCutoffTimeMs = globalThis.String(object.transferCutoffTimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferEtaMs !== '0') {
            obj.transferEtaMs = message.transferEtaMs;
        }
        if (message.transferCutoffTimeMs !== undefined && message.transferCutoffTimeMs !== '0') {
            obj.transferCutoffTimeMs = message.transferCutoffTimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.GetEtaResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEtaResponse();
        message.transferEtaMs = object.transferEtaMs ?? '0';
        message.transferCutoffTimeMs = object.transferCutoffTimeMs ?? '0';
        return message;
    },
};
function createBaseGetTransferRequestsRequest() {
    return {};
}
exports.GetTransferRequestsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetTransferRequestsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetTransferRequestsRequest();
        return message;
    },
};
function createBaseGetTransferRequestsResponse() {
    return { requests: [] };
}
exports.GetTransferRequestsResponse = {
    fromJSON(object) {
        const message = {
            requests: globalThis.Array.isArray(object?.requests)
                ? object.requests.map((e) => transfer_request_1.TransferRequest.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requests?.length) {
            obj.requests = message.requests.map((e) => transfer_request_1.TransferRequest.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferRequestsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferRequestsResponse();
        message.requests = object.requests?.map((e) => transfer_request_1.TransferRequest.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetTransferRequestRequest() {
    return { transferRequestId: '' };
}
exports.GetTransferRequestRequest = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferRequestRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferRequestRequest();
        message.transferRequestId = object.transferRequestId ?? '';
        return message;
    },
};
function createBaseGetTransferRequestResponse() {
    return { request: transfer_request_1.TransferRequest.fromPartial({}) };
}
exports.GetTransferRequestResponse = {
    fromJSON(object) {
        const message = {
            request: isSet(object.request)
                ? transfer_request_1.TransferRequest.fromJSON(object.request)
                : transfer_request_1.TransferRequest.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.request !== undefined) {
            obj.request = transfer_request_1.TransferRequest.toJSON(message.request);
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferRequestResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferRequestResponse();
        message.request = (object.request !== undefined && object.request !== null)
            ? transfer_request_1.TransferRequest.fromPartial(object.request)
            : transfer_request_1.TransferRequest.fromPartial({});
        return message;
    },
};
function createBaseDeleteTransferRequestRequest() {
    return { transferRequestId: '' };
}
exports.DeleteTransferRequestRequest = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        return obj;
    },
    create(base) {
        return exports.DeleteTransferRequestRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteTransferRequestRequest();
        message.transferRequestId = object.transferRequestId ?? '';
        return message;
    },
};
function createBaseDeleteTransferRequestResponse() {
    return {};
}
exports.DeleteTransferRequestResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeleteTransferRequestResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeleteTransferRequestResponse();
        return message;
    },
};
function createBaseUpdateTransferRequestStatusRequest() {
    return { transferRequestId: '', status: transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS };
}
exports.UpdateTransferRequestStatusRequest = {
    fromJSON(object) {
        const message = {
            transferRequestId: isSet(object.transferRequestId)
                ? globalThis.String(object.transferRequestId)
                : '',
            status: isSet(object.status)
                ? (0, transfer_request_status_1.transferRequestStatusFromJSON)(object.status)
                : transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transferRequestId !== '') {
            obj.transferRequestId = message.transferRequestId;
        }
        if (message.status !== transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS) {
            obj.status = (0, transfer_request_status_1.transferRequestStatusToJSON)(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateTransferRequestStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTransferRequestStatusRequest();
        message.transferRequestId = object.transferRequestId ?? '';
        message.status = object.status ?? transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS;
        return message;
    },
};
function createBaseUpdateTransferRequestStatusResponse() {
    return {};
}
exports.UpdateTransferRequestStatusResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateTransferRequestStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateTransferRequestStatusResponse();
        return message;
    },
};
function createBaseCancelPendingRequest() {
    return { paymentId: '' };
}
exports.CancelPendingRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.CancelPendingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCancelPendingRequest();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseCancelPendingResponse() {
    return { status: transfer_status_1.TransferStatus.fromPartial({}) };
}
exports.CancelPendingResponse = {
    fromJSON(object) {
        const message = {
            status: isSet(object.status)
                ? transfer_status_1.TransferStatus.fromJSON(object.status)
                : transfer_status_1.TransferStatus.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== undefined) {
            obj.status = transfer_status_1.TransferStatus.toJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.CancelPendingResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCancelPendingResponse();
        message.status = (object.status !== undefined && object.status !== null)
            ? transfer_status_1.TransferStatus.fromPartial(object.status)
            : transfer_status_1.TransferStatus.fromPartial({});
        return message;
    },
};
function createBaseGetTransferMinimumConfigRequest() {
    return { currency: '' };
}
exports.GetTransferMinimumConfigRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferMinimumConfigRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferMinimumConfigRequest();
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseGetTransferMinimumConfigResponse() {
    return { config: exports.TransferMinimumConfig.fromPartial({}) };
}
exports.GetTransferMinimumConfigResponse = {
    fromJSON(object) {
        const message = {
            config: isSet(object.config)
                ? exports.TransferMinimumConfig.fromJSON(object.config)
                : exports.TransferMinimumConfig.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.config !== undefined) {
            obj.config = exports.TransferMinimumConfig.toJSON(message.config);
        }
        return obj;
    },
    create(base) {
        return exports.GetTransferMinimumConfigResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetTransferMinimumConfigResponse();
        message.config = (object.config !== undefined && object.config !== null)
            ? exports.TransferMinimumConfig.fromPartial(object.config)
            : exports.TransferMinimumConfig.fromPartial({});
        return message;
    },
};
function createBaseLookupFeeSchemaRequest() {
    return { currency: '' };
}
exports.LookupFeeSchemaRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeSchemaRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeSchemaRequest();
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseLookupFeeSchemaResponse() {
    return {
        debitCardFunding: undefined,
        creditCardFunding: undefined,
        debitCardWithdrawal: undefined,
    };
}
exports.LookupFeeSchemaResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.debitCardFunding)) {
            message.debitCardFunding = fee_schema_1.FeeSchema.fromJSON(object.debitCardFunding);
        }
        if (isSet(object.creditCardFunding)) {
            message.creditCardFunding = fee_schema_1.FeeSchema.fromJSON(object.creditCardFunding);
        }
        if (isSet(object.debitCardWithdrawal)) {
            message.debitCardWithdrawal = fee_schema_1.FeeSchema.fromJSON(object.debitCardWithdrawal);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.debitCardFunding !== undefined) {
            obj.debitCardFunding = fee_schema_1.FeeSchema.toJSON(message.debitCardFunding);
        }
        if (message.creditCardFunding !== undefined) {
            obj.creditCardFunding = fee_schema_1.FeeSchema.toJSON(message.creditCardFunding);
        }
        if (message.debitCardWithdrawal !== undefined) {
            obj.debitCardWithdrawal = fee_schema_1.FeeSchema.toJSON(message.debitCardWithdrawal);
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeSchemaResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeSchemaResponse();
        message.debitCardFunding =
            (object.debitCardFunding !== undefined && object.debitCardFunding !== null)
                ? fee_schema_1.FeeSchema.fromPartial(object.debitCardFunding)
                : undefined;
        message.creditCardFunding =
            (object.creditCardFunding !== undefined && object.creditCardFunding !== null)
                ? fee_schema_1.FeeSchema.fromPartial(object.creditCardFunding)
                : undefined;
        message.debitCardWithdrawal =
            (object.debitCardWithdrawal !== undefined && object.debitCardWithdrawal !== null)
                ? fee_schema_1.FeeSchema.fromPartial(object.debitCardWithdrawal)
                : undefined;
        return message;
    },
};
function createBaseLookupFeeRequest() {
    return { type: transfer_fee_type_1.TransferFeeType.INVALID_TRANSFER_FEE_TYPE, amount: amount_1.Amount.fromPartial({}) };
}
exports.LookupFeeRequest = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type)
                ? (0, transfer_fee_type_1.transferFeeTypeFromJSON)(object.type)
                : transfer_fee_type_1.TransferFeeType.INVALID_TRANSFER_FEE_TYPE,
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== transfer_fee_type_1.TransferFeeType.INVALID_TRANSFER_FEE_TYPE) {
            obj.type = (0, transfer_fee_type_1.transferFeeTypeToJSON)(message.type);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeRequest();
        message.type = object.type ?? transfer_fee_type_1.TransferFeeType.INVALID_TRANSFER_FEE_TYPE;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseLookupFeeResponse() {
    return { amount: undefined, schema: undefined };
}
exports.LookupFeeResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.schema)) {
            message.schema = fee_schema_1.FeeSchema.fromJSON(object.schema);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.schema !== undefined) {
            obj.schema = fee_schema_1.FeeSchema.toJSON(message.schema);
        }
        return obj;
    },
    create(base) {
        return exports.LookupFeeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLookupFeeResponse();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.schema = (object.schema !== undefined && object.schema !== null)
            ? fee_schema_1.FeeSchema.fromPartial(object.schema)
            : undefined;
        return message;
    },
};
/**
 * Money transfer service.
 */
class TransferServiceClient {
    rpc;
    name = 'com.step.transfer.proto.TransferService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/transfer';
    methods = [{
            name: 'SendMoneyV2',
            requestType: exports.SendMoneyV2Request,
            responseType: exports.SendMoneyV2Response,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'RequestMoney',
            requestType: exports.RequestMoneyRequest,
            responseType: exports.RequestMoneyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetEta',
            requestType: exports.GetEtaRequest,
            responseType: exports.GetEtaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTransferRequests',
            requestType: exports.GetTransferRequestsRequest,
            responseType: exports.GetTransferRequestsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTransferRequest',
            requestType: exports.GetTransferRequestRequest,
            responseType: exports.GetTransferRequestResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DeleteTransferRequest',
            requestType: exports.DeleteTransferRequestRequest,
            responseType: exports.DeleteTransferRequestResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateTransferRequestStatus',
            requestType: exports.UpdateTransferRequestStatusRequest,
            responseType: exports.UpdateTransferRequestStatusResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'CancelPending',
            requestType: exports.CancelPendingRequest,
            responseType: exports.CancelPendingResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetTransferMinimumConfig',
            requestType: exports.GetTransferMinimumConfigRequest,
            responseType: exports.GetTransferMinimumConfigResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'LookupFee',
            requestType: exports.LookupFeeRequest,
            responseType: exports.LookupFeeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'LookupFeeSchema',
            requestType: exports.LookupFeeSchemaRequest,
            responseType: exports.LookupFeeSchemaResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    sendMoneyV2(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    requestMoney(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getEta(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getTransferRequests(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getTransferRequest(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    deleteTransferRequest(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    updateTransferRequestStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    cancelPending(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getTransferMinimumConfig(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a calculated fee amount.
     */
    lookupFee(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns fees schemas applicable to the current user.
     */
    lookupFeeSchema(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.TransferServiceClient = TransferServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=transfer-service.js.map